// removed by extract-text-webpack-plugin
module.exports = {"root":"SubscriptionRenew__root___-d_jb","reg-subscription__upgrade":"SubscriptionRenew__reg-subscription__upgrade___1Xsjy","button":"SubscriptionRenew__button___on5nF"};